import {gql} from '@apollo/client';
export const UPDATE_CLUB_FCM_TOKEN = gql`
  mutation updateClubFCMToken($email: String!, $fcmToken: String!) {
    updateClubFCMToken(email: $email, fcmToken: $fcmToken)
  }
`;

export const UPDATE_CLUB_PROFIT_PERCENTAGES = gql`
  mutation updateClubProfitPercentages($clubId: String!, $pegProfits: [PegProfitPercentageInput!]!, $offerDiscountPercentage: String!, $useGoldProfitsForAllShelves: Boolean) {
    updateClubProfitPercentages(clubId: $clubId, pegProfits: $pegProfits, offerDiscountPercentage: $offerDiscountPercentage, useGoldProfitsForAllShelves: $useGoldProfitsForAllShelves) {
      id
      useGoldProfitsForAllShelves
      offerDiscountPercentage
      bottleService {
        shelf
        simulatePrice
        numberOfPegs {
          pegCount
          pegTitle
          totalPrice
          actualClubPrice
          validity
          customerPrice
          platformFee
          gst
          mrp
          discountPercentage
          profitPercentage
          profitAmount
        }
      }
    }
  }
`;

export const SET_VENUE_SUSPENSION = gql`
  mutation setVenueSuspension($clubId: String!, $startDate: String!, $endDate: String!, $reason: String!) {
    setVenueSuspension(clubId: $clubId, startDate: $startDate, endDate: $endDate, reason: $reason) {
      id
      isAvailable
      isSuspended
      availabilityMessage
      suspension { source startDate endDate reason }
    }
  }
`;

export const CLEAR_VENUE_SUSPENSION = gql`
  mutation clearVenueSuspension($clubId: String!) {
    clearVenueSuspension(clubId: $clubId) {
      id
      isAvailable
      isSuspended
      availabilityMessage
      suspension { source startDate endDate reason }
    }
  }
`;
export const UPDATE_CLUB_ALCOHOL_INTAKE_DETAILS = gql`
  mutation updateClubAlcoholIntakeDetails($clubId: String, $bottleService: [BottleServiceInput], $useGoldDiscountsForAllShelves: Boolean, $emailVerificationId: String) {
  updateClubAlcoholIntakeDetails(clubId: $clubId, bottleService: $bottleService, useGoldDiscountsForAllShelves: $useGoldDiscountsForAllShelves, emailVerificationId: $emailVerificationId) {
    useGoldDiscountsForAllShelves
    id
    city
    name
    bottleService {
      shelf
      simulatePrice
      numberOfPegs {
        pegCount
        pegTitle
        totalPrice
        actualClubPrice
        validity
        customerPrice
        platformFee
        gst
        mrp
        discountPercentage
        profitPercentage
        profitAmount
      }
    }
  }
}
`;

export const UPDATE_CLUB_ALCOHOL_LIST = gql`
    mutation updateClubAlcoholList($clubId: String, $alcoholList: [AlcoholListInput]) {
        updateClubAlcoholList(clubId: $clubId, alcoholList: $alcoholList) {
            alcoholList {
                name
                image
                shelf
                type
                isAvailable
            }
        }
    }
`;

export const ADD_CLUB = gql`
  mutation addClub($name: String, $address: String, $city: String, $state: String, $country: String, $zipCode: String, $localityArea: String, $email: String, $contactPersonName: String, $contactPersonNumber: String) {
  addClub(name: $name, address: $address, city: $city, state: $state, country: $country, zipCode: $zipCode, localityArea: $localityArea, email: $email, contactPersonName: $contactPersonName, contactPersonNumber: $contactPersonNumber) {
    id
    name
    address
    city
    state
    country
    zipCode
    localityArea
    email
    image
    enrolledStatus
    priceIndicator
    eventList
    contactPersonName
    contactPersonNumber
    openingTime
    closingTime
    bottleService {
      shelf
      simulatePrice
      numberOfPegs {
        pegCount
        pegTitle
        totalPrice
        actualClubPrice
        validity
        customerPrice
        platformFee
        gst
        mrp
        discountPercentage
      }
    }
    alcoholList {
      name
      image
      shelf
      type
      isAvailable
    }
  }
}
`;

export const UPDATE_CLUB_PROFILE = gql`
    mutation updateClubProfileMutation($image: String, $clubImageFileId: String, $profileImages: [ClubProfileImageInput!], $city: String, $state: String, $country: String, $email: String, $name: String, $contactPersonName: String, $contactPersonNumber: String, $address: String, $zipCode: String, $localityArea: String, $clubId: String) {
  updateClubProfile(image: $image, clubImageFileId: $clubImageFileId, profileImages: $profileImages, city: $city, state: $state, country: $country, email: $email, name: $name, contactPersonName: $contactPersonName, contactPersonNumber: $contactPersonNumber, address: $address, zipCode: $zipCode, localityArea: $localityArea, clubId: $clubId) {
    id
    name
    address
    city
    state
    country
    zipCode
    localityArea
    email
    image
    clubImageFileId
    profileImages {
      url
      fileId
    }
    enrolledStatus
    priceIndicator
    eventList
    contactPersonName
    contactPersonNumber
    openingTime
    closingTime
    bottleService {
      shelf
      simulatePrice
      numberOfPegs {
        pegCount
        pegTitle
        totalPrice
        actualClubPrice
        validity
        customerPrice
        platformFee
        gst
        mrp
        discountPercentage
      }
    }
    alcoholList {
      name
      image
      shelf
      type
      isAvailable
    }
  }
}
`;

export const ADD_HAPPY_HOURS = gql`
    mutation addHappyHours($happyHours: HappyHoursInput!, $clubId: String) {
      addHappyHours(happyHours: $happyHours, clubId: $clubId) {
        id
        name
        address
        city
        state
        country
        zipCode
        email
        image
        enrolledStatus
        priceIndicator
        eventList
        contactPersonName
        contactPersonNumber
        openingTime
        closingTime
        bottleService {
          shelf
          simulatePrice
          numberOfPegs {
            pegCount
            pegTitle
            totalPrice
            actualClubPrice
            validity
            customerPrice
            platformFee
            gst
            mrp
            discountPercentage
          }
        }
        alcoholList {
          name
          image
          shelf
          type
          isAvailable
        }
        happyHours {
          isActive
          offerName
          offerDescription
          offerImage
          offerImageFileId
          offerStartDate
          offerEndDate
          offerStartTime
          offerEndTime
          offerRestrictions
          offerValidDays
          offerValidity
        }
      }
    }
`

export const REQUEST_INTAKE_EMAIL_VERIFICATION = gql`
  mutation RequestIntakeEmailVerification($clubId: String!, $bottleService: [BottleServiceInput], $useGoldDiscountsForAllShelves: Boolean) {
    requestIntakeEmailVerification(clubId: $clubId, bottleService: $bottleService, useGoldDiscountsForAllShelves: $useGoldDiscountsForAllShelves)
  }
`;
export const VERIFY_INTAKE_EMAIL = gql`
  mutation VerifyIntakeEmail($challengeId: String!, $secret: String!) {
    verifyIntakeEmail(challengeId: $challengeId, secret: $secret)
  }
`;
